export default __webpack_public_path__ + "static/media/photo--lg--hockey5.1fb2cf52.jpg";